/**
 * Module Access Restricted Component
 * Shows upgrade message when user doesn't have access to a module
 */

import React from 'react';
import { Box, Card, CardContent, Typography, Button, Alert } from '@mui/material';
import { Lock, Upgrade } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface ModuleAccessRestrictedProps {
  module: string;
  moduleDisplayName?: string;
}

const ModuleAccessRestricted: React.FC<ModuleAccessRestrictedProps> = ({
  module: _module,
  moduleDisplayName: _moduleDisplayName,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Card sx={{ maxWidth: 600, width: '100%' }}>
        <CardContent sx={{ textAlign: 'center', p: 4 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <Lock sx={{ fontSize: 64, color: 'warning.main' }} />
          </Box>

          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Access Restricted
          </Typography>

          <Typography variant="h5" color="text.secondary" paragraph sx={{ mt: 2, mb: 3 }}>
            Module Access Restricted
          </Typography>

          <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
            <Typography variant="body1">
              This module is not available in your current plan. Please contact your administrator
              to upgrade your plan to access this feature.
            </Typography>
          </Alert>

          <Box display="flex" gap={2} justifyContent="center">
            <Button variant="outlined" onClick={() => navigate('/admin/dashboard')}>
              Go to Dashboard
            </Button>
            <Button
              variant="contained"
              startIcon={<Upgrade />}
              onClick={() => navigate('/admin/settings')}
            >
              Contact Admin
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ModuleAccessRestricted;
